import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

export const initialState = {
  selectedUnfamiliarWord: null,
};

const modelingReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.SET_LEVEL_INDEX:
      return {
        ...state,
        selectedUnfamiliarWord: null,
      };

    case REDUX_ACTIONS.SELECT_UNFAMILIAR_WORD:
      return {
        ...state,
        selectedUnfamiliarWord: action.payload.selectedUnfamiliarWord,
      };
    default:
      return state;
  }
};

export default modelingReducer;
